import TrilogyHub from "./TrilogyHub";

export default function TrilogyChaines() {
  return (
    <TrilogyHub
      slug="les-chaines-du-vivant"
      subtitle="Trilogie d'anticipation"
      title="Les Chaînes du Vivant — la trilogie"
      metaTitle="Les Chaînes du Vivant — trilogie d'anticipation de Bruno Courtin"
      metaDescription="Les Chaînes du Vivant, trois romans d'anticipation de Bruno Courtin : NeuroAurum, Les Seuils intérieurs, Les Mots des Puissants. Une trilogie sur la mémoire, la liberté intérieure et les récits qui gouvernent nos vies."
      coverUrl="/api/files/chaines-vivant-t1-neuroaurum.png"
      tomeSlugs={[
        "les-chaines-du-vivant-tome-1-neuroaurum",
        "les-chaines-du-vivant-les-seuils-interieurs",
        "les-chaines-du-vivant-tome-3",
      ]}
      otherNovels={[
        "mauritia-le-peuple-de-l-eau",
        "larbre-qui-cachait-la-foret",
        "le-feu-interieur",
        "les-heritages-du-vivant",
        "projet-lithium-luminia",
      ]}
      intro={
        <>
          <p>
            Les Chaînes du Vivant est une trilogie d'anticipation qui interroge la manière dont nos vies
            intérieures — mémoire, langage, croyances — deviennent aujourd'hui des terrains d'influence,
            d'ingénierie et de gouvernement. Trois romans, trois entrées, une même exigence : nommer
            ce qui nous relie et ce qui nous entrave.
          </p>
          <p>
            <strong>Tome I — NeuroAurum : Libres, nous sommes</strong> met en scène une technologie
            qui prétend améliorer nos mémoires — au prix d'un pouvoir inédit sur ce que nous croyons
            avoir vécu. <strong>Tome II — Les Seuils intérieurs : Libre, je suis</strong> plonge dans
            l'intime d'une femme qui découvre les seuils que son histoire a posés sans qu'elle en
            connaisse les termes. <strong>Tome III — Les Mots des Puissants : Le peuple de l'Air —
            Libre, je crois…</strong> déplace la question sur le terrain des récits publics : qui
            détient les mots, détient les comportements.
          </p>
          <p>
            La trilogie n'oppose pas la technologie à l'humain. Elle interroge plutôt ce que nous
            faisons de ce que nous savons. Elle montre que la liberté ne se prouve pas par les
            promesses ; elle se conquiert par la reconnaissance patiente de ce qui, en nous, avait
            été façonné sans nous.
          </p>
        </>
      }
    />
  );
}
